import { render, staticRenderFns } from "./EscalationChatsTable.vue?vue&type=template&id=4d0fbdd4&"
import script from "./EscalationChatsTable.vue?vue&type=script&lang=ts&"
export * from "./EscalationChatsTable.vue?vue&type=script&lang=ts&"
import style0 from "./EscalationChatsTable.vue?vue&type=style&index=0&id=4d0fbdd4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports